/**
 * İlk girişteki url değerini kaydeder
 */
const SaveInitialUrl = () => {
    const currentUrl = window.location.href;
    const savedUrl = localStorage.getItem('initialUrl');
    if (!savedUrl && !HasToken()) {
        if (window.location.pathname != "/" && !currentUrl.includes("login") && !currentUrl.includes("logout") && !currentUrl.includes("dashboard"))
            localStorage.setItem('initialUrl', currentUrl);
    }
}

/**
 * İlgili sayfaya yönlendirir
 */
const GoToRedirectPage = () => {
    const initialUrl = localStorage.getItem('initialUrl');
    if (initialUrl) {
        localStorage.removeItem('initialUrl');
        window.location.href = initialUrl;
    } else {
        window.location.href = '/dashboard';
    }
}

/**
 * Token var mı yok mu kontrol eder
 * @returns boolean
 */
const HasToken = () => {
    const token = localStorage.getItem('ssotoken');
    return token !== undefined && token !== null && token !== '';
}

/**
 * SSO sayfasına yönlendirir
 */
const GotoSSO = () => {
    const redirect_uri = window.location.origin;
    window.location.replace(`${process.env.REACT_APP_SSO_LINK}/Authorization?client_id=${process.env.REACT_APP_APP_ID}:${process.env.REACT_APP_APP_KEY_HASH}&redirect_uri=${redirect_uri}/login&response_type=code&scope=openid profile HRPHOTO&response_mode=query`);
}

/**
 * Tokenları siler
 */
const ClearTokens = () => {
    localStorage.removeItem("ssotoken");
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpire");
}

export { SaveInitialUrl, GoToRedirectPage, HasToken, GotoSSO, ClearTokens }